// extracted by mini-css-extract-plugin
module.exports = {"shine":"global-module--shine--4y6St"};